import overrideIfMinBetNumberEnabled from "./MinBetNumberRegistrator";
overrideIfMinBetNumberEnabled(function () {
    (function (singleSPSlipMode) {
        if (!singleSPSlipMode) {
            return;
        }
        var _isDepositValid = singleSPSlipMode.isDepositValid;
        $.extend(singleSPSlipMode, {
            isDepositValid(depositValue, selection) {
                return _isDepositValid.call(this, depositValue, selection) && selection.MinBetNumber === 1;
            }
        });
    })(window.SingleSPSlipMode.prototype);
    BetSlip.OnLoaded["SingleSPSlipModeWithMBN"] = function (betSlip) {
        if (!(betSlip && betSlip.CurrentMode)) {
            return;
        }
        betSlip.CurrentMode.isDepositValid = function (depositValue, selection) {
            return window.SingleSPSlipMode.prototype.isDepositValid.call(betSlip.CurrentMode, depositValue, selection);
        };
    };
});
//# sourceMappingURL=SingleSPSlipMode.js.map